// src/components/common/Form/SlideTime.js
import React from "react";

const SlideTime = ({ data, isActive, timeOptions, onSelect }) => (
  <div className={`carousel-item c-item ${isActive ? "active" : ""}`}>
    <h1 className="display-2 fw-bolder text-capitalize mb-5 hero-title">
      {data.titleBefore} <span className="text-color">{data.titleRed}</span>
      {data.titleAfter}
    </h1>
    <div className="container">
      <div className="row">
        {Object.entries(timeOptions).map(([key, value], index) => (
          <div className="col-12 col-md-4 mb-2" key={index}>
            <button type="button" className="custom-btn medium" onClick={() => onSelect(key)}>
              {value}
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SlideTime;
